import { NotificationsService } from 'angular2-notifications';
import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { Router } from '@angular/router';
import { CompanyService } from './../services/company.service';
import { Company } from './../interfaces/company.model';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';

@Component({
  selector: 'app-main',
  templateUrl: './company-select.component.html',
  styles: ['.select-company-page { margin: 0 auto; text-align:center; width: 760px; }',
    '']
})

export class CompanySelectComponent implements OnInit {
  noCompanies: Boolean;
  companies: Company[];

  constructor(
    private companyService: CompanyService,
    private localStorageService: LocalStorageService,
    private breadcrumbsService: BreadcrumbsService,
    private notificationsService: NotificationsService,
    private router: Router

  ) {

  }

  ngOnInit() {
    this.breadcrumbsService.translateBreadcrumb('/company/select', 'Wybór firmy');
 
    this.companyService.getUserCompanies()
      .subscribe(
      (companies: Company[]) => {
        this.companies = companies;
        if (!this.companies.length) {
          this.noCompanies = true;
        }
      },
      (error) => {
        this.notificationsService.error('Ups', 'Błąd podczas pobierania informacji o firmach uzytkownika');
      }
    );
  }

  changeCompany(companyID) {
    this.localStorageService.set('company', companyID);
    this.router.navigateByUrl('/panel');
  }
}



// WEBPACK FOOTER //
// ./src/app/company-select/company-select.component.ts